import { SxProps, Theme } from "@mui/material/styles";

export const footerContainer: SxProps<Theme> = (theme) => ({
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    gap: theme.spacing(2),
    backgroundColor: theme.palette.primary.main,
    px: theme.spacing(2),
    py: theme.spacing(3),
    color: theme.palette.common.white,
});

export const footerItem: SxProps<Theme> = (theme) => ({
    margin: theme.spacing(1),
});

export const footerLinkContainer: SxProps<Theme> = (theme) => ({
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "center",
    alignItems: "center",
    gap: theme.spacing(2),
});

export const footerLink: SxProps<Theme> = (theme) => ({
    color: theme.palette.common.white,
    fontFamily: "HsvSlab",
    fontWeight: "bold",
    textTransform: "uppercase",
    textDecoration: "none",
    "&:hover": {
        textDecoration: "underline",
    },
});

export const footerImg: SxProps = {
    width: 200,
    objectFit: "contain",
};
